import React from "react";
import "assets/scss/partials/modal.scss";
import { ReactComponent as MinimizeIcon } from "assets/img/icons/minimize.svg";
import { ReactComponent as MaximizeIcon } from "assets/img/icons/maximize.svg";
import classNames from "classnames";
import { useDraggableContext } from "store/contexts/draggableModalContext";
import RingCentralComponentMeeting from "../RingCentralMeeting/RingCentralComponentMeeting";
import "@ringcentral/video-sdk-react/dist/index.css";

function RingCentralPremiumMeeting() {
  const { handleMinimize, isMinimized } = useDraggableContext();

  const DisplayImageModal = () => {
    return (
      <div
        className={classNames({
          premiumModalRoot: true,
          premiumModalRootMinimized: isMinimized ? true : false,
        })}
      >
        <div
          className={classNames({
            premiumModalHeader: true,
            movePremiumModalHeader: isMinimized ? true : false,
          })}
        >
          <div className="premiumHeader">
            {!isMinimized && (
              <MinimizeIcon className="premiumSvg" onClick={handleMinimize} />
            )}
            {isMinimized && (
              <MaximizeIcon className="premiumSvg" onClick={handleMinimize} />
            )}
          </div>
        </div>
        <div className="premiumModal">
          <RingCentralComponentMeeting />
        </div>
      </div>
    );
  };

  return <DisplayImageModal />;
}

export default RingCentralPremiumMeeting;
